import React from 'react';

export interface AdminStatCardProps {
  title: string;
  value: number | string;
  subtitle?: string;
  icon: string;
  iconColor: string;
  borderColor?: string;
  valueColor?: string;
}

export function AdminStatCard({
  title,
  value,
  subtitle,
  icon,
  iconColor,
  borderColor,
  valueColor,
}: AdminStatCardProps) {
  const borderClass = borderColor ? `border-${borderColor}` : '';
  const valueClass = valueColor ? `text-${valueColor}` : '';

  const formattedValue =
    typeof value === 'number' ? value.toLocaleString() : value;

  return (
    <div className={`card shadow-sm h-100 ${borderClass}`}>
      <div className="card-body">
        <div className="d-flex align-items-center justify-content-between mb-2">
          <h6 className="text-muted mb-0">{title}</h6>
          <i
            className={`bi bi-${icon} text-${iconColor}`}
            style={{ fontSize: '1.5rem' }}
          />
        </div>
        <h2 className={`mb-0 ${valueClass}`}>{formattedValue}</h2>
        {subtitle && <small className="text-muted">{subtitle}</small>}
      </div>
    </div>
  );
}

export default AdminStatCard;
